import * as React from "react";
const SvgLogo = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 25.0002H25.8016V17.2004L31 11H10.1984V18.7998L5 25.0002Z", stroke: "#171A1C", strokeWidth: 4.00006 }));
export default SvgLogo;
